import { Fragment, useEffect } from 'react'
import { Helmet } from 'react-helmet'

import useScript from '~hooks/useScript'

const APIReference = () => {
  const [loaded] = useScript(
    'https://unpkg.com/swagger-ui-dist@3/swagger-ui-bundle.js'
  )

  useEffect(() => {
    if (loaded) {
      window.SwaggerUIBundle({
        url: 'https://api.gremlin.com/v1/swagger.json',
        dom_id: '#swagger-ui',
        components: {
          // Overwrite the following components
          authorizeBtn: () => null,
          info: () => null,
          parametersRow: () => null,
          schemes: () => null,
          TryItOutButton: () => null,
        },
        deepLinking: true,
        docExpansion: 'none',
        operationSorter: 'alpha',
        tagSorter: 'alpha',
      })
    }
  }, [loaded])

  return (
    <Fragment>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          href="https://unpkg.com/swagger-ui-dist@3.42.0/swagger-ui.css"
        />
      </Helmet>
      <div
        id="swagger-ui"
        css={{
          '.information-container, .scheme-container': {
            display: 'none',
          },

          'a:not([class])': {
            padding: 0,
            background: 'transparent',
          },

          table: {
            boxShadow: 'none',
            border: 0,
          },

          'tr:hover, tr:focus': {
            background: 'transparent',
          },

          '.markdown': {
            'p:only-child': {
              margin: 0,
            },

            'h2, h3': {
              margin: 0,
            },
          },
        }}
      />
    </Fragment>
  )
}

export default APIReference
